import { render, staticRenderFns } from "./ViewAnexosPreview.vue?vue&type=template&id=a06d8fca&scoped=true&"
import script from "./ViewAnexosPreview.vue?vue&type=script&lang=js&"
export * from "./ViewAnexosPreview.vue?vue&type=script&lang=js&"
import style0 from "./ViewAnexosPreview.vue?vue&type=style&index=0&id=a06d8fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d8fca",
  null
  
)

export default component.exports